<template>
  <div class="title-card" :class="{ 'selected': selected }" @click="handleClick">
    <div class="title-line-1">{{ title }}</div>
    <div class="title-line-2">的规范使用与临床经验分享</div>
  </div>
</template>

<script setup>
import { defineProps, defineEmits } from 'vue';

// 定义组件的props
const props = defineProps({
  title: {
    type: String,
    required: true,
    default: ''
  },
  value: {
    type: [Object, String, Number],
    default: null
  },
  selected: {
    type: Boolean,
    default: false
  }
});

// 定义组件的事件
const emit = defineEmits(['click']);

// 处理点击事件
const handleClick = () => {
  emit('click', props.value || props.title);
};
</script>

<style scoped>
.title-card {
  display: flex;
  flex-direction: column;
  border: 1px solid #145294;
  border-radius: 8px;
  padding: 12px 16px;
  background-color: #ffffff;
  position: relative;
  box-sizing: border-box;
  transition: all 0.3s ease;
}

.title-card.selected {
  border-left: 4px solid #145294;
  background-color: #f0f4f8;
}

.title-line-1 {
  font-size: 16px;
  font-weight: 500;
  color: #333333;
  margin-bottom: 4px;
}

.title-line-2 {
  font-size: 14px;
  color: #666666;
}

.click-text {
  position: absolute;
  right: 16px;
  top: 50%;
  transform: translateY(-50%);
  font-size: 14px;
  color: #145294;
  border-bottom: 1px solid #145294;
  cursor: pointer;
}
</style>